export default __webpack_public_path__ + "static/17-532243452119209ad30399b4df9fab83.png";